<template>
  <header
    id="top"
    class="bg-center cover flex flex-column justify-center ts1 w-100 white vh-100"
    :style="`background-image: url(/images/pico-header-01.jpg)`">
    <div class="center w-100 w-80-ns z-1">
      <div class="mt6-ns ph3 ph0-ns w-100 w-70-l w-40-xl">
        <p class="f6">
          <a href="https://ideum.com">Made by
            <img
              :src="require('@/assets/images/ideum-logo.svg')"
              class="mw3"
              alt="Ideum logo">
          </a>
        </p>
        <h1 class="f0-ns f1 fw3 lh-title mv3"><span class="tracked ttu">Pico</span> Multitouch Coffee Table</h1>
        <p class="f6 f4-ns lh-double mb3 measure">Ideum, makers of integrated, ruggedized multitouch tables and touch walls, announces their 5th generation smart coffee table: the Pico. Pico is available with either a 43”, 49”, or 55” 4K Ultra HD interactive LG commercial display with 3M<sup class="super">TM</sup> touch technology.</p>
        <img
          id="header-arrow"
          :src="require('@/assets/images/pico-arrow-01.svg')"
          alt="decorative arrow"
          class="absolute h3 pointer z-1"
          @click="jumpToId('productivity')">
      </div>
    </div>
  </header>
</template>

<script>
import jump from 'jump.js'

export default {
  name: 'TheHeader',

  methods: {
    jumpToId (id) {
      jump(`#${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/_variables.scss';

header {
  position: relative;
  &::after {
    background-image: linear-gradient(to right, rgba(0, 0, 0, .5), rgba(0, 0, 0, .1));
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    @media #{ $breakpoint-xlarge } {
      background-image: linear-gradient(to right, rgba(0, 0, 0, .4), rgba(0, 0, 0, 0));
      width: 55%;
    }
  }
}

#header-arrow {
  animation: bounce 2s var(--ease-cubic) infinite;
}

@media screen and (max-height: 480px) {
  .f0-ns {
    font-size: 2rem;
  }

  .f4-ns {
    font-size: 1rem;
  }

  .h3 {
    height: 2rem;
  }

  .mt6-ns {
    margin-top: 0;
  }
}
</style>
